import { Text, Title } from "@clipboard-health/ui-react";
import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useGetAttendanceScoreHistory } from "@src/appV2/AttendanceScore/api/useGetAttendanceScoreHistory";

import { AttendanceScoreHistoryRowItem } from "./attendanceScoreHistoryRow";

export function AttendanceScoreRecentActivity(props: { workerUserId: string }) {
  const { workerUserId } = props;
  const { data: attendanceScoreHistory, isSuccess: attendanceScoreHistoryIsSuccess } =
    useGetAttendanceScoreHistory({ userId: workerUserId });
  return (
    <Stack spacing={0.5}>
      <Title bold component="h3">
        Recent Activity
      </Title>
      <Text gutterBottom variant="subtitle1" color="text.secondary">
        {!attendanceScoreHistoryIsSuccess && "Loading..."}
        {attendanceScoreHistoryIsSuccess &&
          (attendanceScoreHistory.scoreLogs.length > 0
            ? "Showing the last 20 events."
            : "No activity yet.")}
      </Text>
      {attendanceScoreHistoryIsSuccess && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ padding: "8px" }}>Date</TableCell>
                <TableCell sx={{ padding: "8px" }}>Event</TableCell>
                <TableCell sx={{ padding: "0px" }}>Change</TableCell>
                <TableCell sx={{ padding: "0px" }} align="right" />
              </TableRow>
            </TableHead>
            <TableBody>
              {attendanceScoreHistory.scoreLogs.map((scoreLog) => (
                <AttendanceScoreHistoryRowItem key={scoreLog.id} scoreLog={scoreLog} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Stack>
  );
}
